export default __webpack_public_path__ + "static/media/Educational.654a5e94.jpg";